$(function ()
{
	if (typeof initFlexSliders === "function") initFlexSliders();
	if (typeof initFeaturedProducts === "function") initFeaturedProducts();
	if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
	if (typeof initForms === "function") initForms();
	if (typeof initContentEventHandlers === "function") initContentEventHandlers();
	if (typeof initHotSpotImages === "function") initHotSpotImages();
	if (typeof initPaymentOptions === "function") initPaymentOptions();

	//IE and edge fallback for object fit css property
	if(!Modernizr.objectfit)
	{
		//content blocks
		if($(el('contentContainer')).length)
		{
			$('.imageCenter').each(function () {
				objectFitFallback($(this));
			});

			$('.imageWrapper').each(function () {
				objectFitFallback($(this));
			});
		}
	}
});

function enableLiveUpload(uploadContainer,uploadResult,uploadLoader)
{
	if(!uploadContainer.hasClass('dz-clickable'))
	{
		uploadContainer.dropzone({
			url: "/index.cfm/content/ajax/upload/content",
			clickable: true,
			success: function(file,oData){
				uploadLoader.toggleClass('hide');
				var imageSource = imagePathContent + oData.fileName;
				var originalImage = uploadContainer.parent().parent().find('.original');
				var originalSource = originalImage.data('original');
				originalImage.attr('data-original',originalSource);
				originalImage.attr('src',imageSource);
				uploadContainer.toggleClass('hide');
			},
			addedfile: function(){
				uploadContainer.addClass('hide');
				uploadLoader.toggleClass('hide');
			}
		});
	}
}

function getSimpleFormValues(oFormEl)
{
	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden') && $(oEl).prop('disabled') !== true && $(oEl).attr('type') !== 'submit')
		{
			var oValueLabel = {};
			oValueLabel       = {};
			oValueLabel.label = $(oEl).prop('name');
			oValueLabel.name  = $(oEl).prop('name');

			switch ($(oEl).attr('type'))
			{
				case "checkbox":
					oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
				default:
					oValueLabel.value = $(oEl).val();
			}
			aElements.push(oValueLabel);
		}
	});

	return aElements;
}

function initContentEventHandlers()
{
	// Hover image hover action
	if ($(window).width() > 1024)
	{
		$(el('contentContainer')).on({
		    mouseenter: function (e) {
				var block = $(e.currentTarget || e.srcElement);
				var height = block.find('.panel-body').height();
				var banner = block.find('.banner');
				var detail = block.find('.detail');
				var opacity = block.find('.panel-body').find('[opacity]').attr('opacity');
				if(typeof opacity === 'undefined') opacity=75;
				opacity = opacity/100;
				var speed = parseInt(banner.attr('speed'));
				banner.css("bottom",'0px');
				banner.stop().animate({height:height},speed,function(){
					detail.css('visibility','visible');
				});
				banner.find('.textBanner').hide();
				banner.css("opacity",opacity);
		    },
		    mouseleave: function (e) {
				var block = $(e.currentTarget || e.srcElement);
				var banner = block.find('.banner');
				var detail = block.find('.detail');

				banner.stop().css("height","");
				banner.find('.textBanner').show();
				banner.css("opacity",1);
				banner.css('bottom','');
				detail.css('visibility','hidden');
		    }
		}, ".hoverimage");
	}
	else
	{
		$(el('contentContainer')).on('click','.hoverimage .original',function(){
			window.location = $(this).closest('.panel-body').find('.detailButton').prop('href');
		});
	}

	$(el('contentContainer')).on('click','.searchShop .doSearch',function(){
		var location = $(this).prev().val();
		if(location !== '')
		{
			searchShop(location,-1,-1);
		}
	});

	$(el('contentContainer')).on('keyup','.searchShop .search',function(e){
		if(e.which === 13)
		{
			var location = $(this).val();
			if(location !== '')
			{
				searchShop(location,-1,-1);
			}
		}
	});

	// anchor menu
	$(el('contentContainer')).on('click','.menu [class*=item]',function(){
		scrollToAnchor($(this).data('anchor'));
	});

	// Swatch click featured products
	$(el('mainContainer')).off('click','.swatch');
	$(el('mainContainer')).on('click','.swatch',function(){
		selectSwatch($(this));
	});

	// init shopmap
	if($(el('contentContainer')).find('.shopmap').length)
	{
		$(el('contentContainer')).on('click','.shopmap .btnSearchShopmap',function(){
			var location = $(this).prev().val();
			if(location !== '')
			{
				geoLookup(location);
			}
		});

		$(el('contentContainer')).on('keyup','.shopmap .edtLocation',function(e){
			if(e.which === 13)
			{
				var location = $(this).val();
				if(location !== '')
				{
					geoLookup(location);
				}
			}
		});

		if(typeof google !== 'undefined')
		{
			google.maps.event.addDomListener(window, 'load', initializeMap);
		}
		$(".featuredproducts .flex-next").on("click", function () {
			$(window).trigger('scroll');
		});
	}

	$(el('mainContainer')).on('click','.showTabPageContent,.showTabHtmlContent,.showTabImageContent',function()
	{
		var currentParent = $(this).closest('.editModeContentDiv');

		currentParent.find('.tabPageContent').addClass('hidden');
		currentParent.find('.tabHtmlContent').addClass('hidden');
		currentParent.find('.tabImageContent').addClass('hidden');

		currentParent.find('.showTabPageContent').removeClass('selected');
		currentParent.find('.showTabHtmlContent').removeClass('selected');
		currentParent.find('.showTabImageContent').removeClass('selected');

		// show other tab
		if($(this).hasClass('disabled'))
		{
			return false;
		}
		else if($(this).hasClass('showTabPageContent'))
		{
			currentParent.find('.tabPageContent').removeClass('hidden');
			currentParent.find('.showTabPageContent').addClass('selected');
		}
		else if($(this).hasClass('showTabHtmlContent'))
		{
			currentParent.find('.tabHtmlContent').removeClass('hidden');
			currentParent.find('.showTabHtmlContent').addClass('selected');

			var htmlEditor = currentParent.find('.htmlEditContent');
			htmlEditor.ckeditor(function(e){
				var editor = $(e).ckeditor().editor;
				editor.setReadOnly(false);
				editor.focus();
			});
		}
		else
		{
			currentParent.find('.tabImageContent').removeClass('hidden');
			currentParent.find('.showTabImageContent').addClass('selected');

			var uploadContainer = currentParent.find('.imageUpload');
			var uploadResult    = currentParent.find('.uploadResult');
			var uploadLoader    = currentParent.find('.uploadLoader');

			enableLiveUpload(uploadContainer,uploadResult,uploadLoader);
		}
	});

	$(el('mainContainer')).on('click','.btnSaveInsertImage',function()
	{
		saveContentInline($(this),'image');
	});

	$(el('mainContainer')).on('click','.btnSaveInsertHtml',function()
	{
		saveContentInline($(this),'html');
	});

	$(el('mainContainer')).on('keyup change blur','.opacity',function()
	{
		$(this).val((parseInt($(this).val())<0)?0:$(this).val());
		$(this).val((parseInt($(this).val())>100)?100:$(this).val());
		$(this).closest('.panel-body').find('[opacity]').attr('opacity',$(this).val());
	});

	$(el('mainContainer')).on('click','.btnProductsAdd', function()
	{
		buyProductsBlockAddSkus($(this).data('skus'));
	});

	var oSteps = $('.steps');
	if(oSteps.length > 0 && window.location.hash !== "")
	{
		var sStepClass = window.location.hash.replace('#','.');
		scrollToElement($(sStepClass));
	}

	$(el('mainContainer')).on('submit','.newsletterBlockForm', function(e)
	{
		e.preventDefault();

		submitNewsletterBlock($(this));
	});

	$(el('mainContainer')).on('click','.productConfigAddToBasket', function(e)
	{
		e.preventDefault();

		productConfigAddToBasketHandler($(this));
	});

	$(el('mainContainer')).on('click','.inputInterestsFrmSubmit', function(e)
	{
		e.preventDefault();

		var oBlock = $(this).parents(".block");
		checked = oBlock.find("input:checkbox[name=userInterests]:checked").length;

        if(!checked) {
			$(".interestsCheckError").show();
            return false;
        } else {
			$(".interestsCheckError").hide();
		}
		submitInterestsForm($(this));
	});

}

function submitInterestsForm(oBtn)
{
	oBtn.prop('disabled',true);
	var oBlock = oBtn.parents(".block");
	var oFrm = oBtn.parents(".interestsFrm");
	var checkedInterests = [];

	oBlock.find("input:checkbox[name=userInterests]:checked").each(function(){
		checkedInterests.push($(this).val());
	});
	var bValid = validateForm(oFrm);
	if(bValid)
	{
		var sParams = "&interests=" + checkedInterests.join(',') + "&firstname=" + oFrm.find(".inputInterestsFrmName").val() + "&email=" + oFrm.find(".inputInterestsFrmEmail").val() + "&formname=" + oFrm.find(".inputFormName").val() + "&redirect=" + oFrm.find(".inputRedirect").val();
		var oCall = callAjax("submitInterestsForm", sParams, "post", "/index.cfm/content/ajax/submitinterestsform");
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				window.location =  oFrm.find(".inputRedirect").val();
			}
			else
			{
				oBtn.prop('disabled',false);

				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		oBtn.prop('disabled',false);
	}
}

function productConfigAddToBasketHandler(oBtn)
{
	var oBlock                = oBtn.parents(".block");
	var oProductConfigSliders = oBlock.find(".productConfigSliders");
	var sSkuList              = [];
	oProductConfigSliders.find(".flexslider").each(function()
	{
		$(this).find(".flexSliderActiveSlides").each(function()
		{
			if(typeof $(this).data("sku") !== "undefined")
			{
				sSkuList.push($(this).data("sku"));
			}
		});
	});

	if(sSkuList.length > 0)
	{
		productConfigAddToBasket(sSkuList);
	}
}

function productConfigAddToBasket(sSkuList)
{
	var sParams = "&skuList= " + sSkuList.join();
	var oCall = callAjax("productConfigAddToBasket", sParams, "post", "/index.cfm/content/ajax/productconfigaddtobasket");
	oCall.success(function(oData)
	{
		if(oData.ErrorType == '')
		{
			// Add to basket successful
			var oBasketDropdowns = $('header:not(.fixedActive) #basketDropdown:visible, header.fixedActive #basketDropdown:visible');
			oBasketDropdowns.html(oData.html).delay(300).queue(function(next)
			{
				oBasketDropdowns.addClass("open");

				setTimeout(function()
				{
					oBasketDropdowns.removeClass('open');
				}, 3000);

				next();
			});
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function initFeaturedProducts()
{
	var oFeaturedProductsItems = $('.featuredproducts .hProductItems');

	if(oFeaturedProductsItems.length > 0)
	{
		oFeaturedProductsItems.each(function(index)
		{
			var sBackgroundColor = (typeof $(this).data('thumbBackgroundColor') !== "undefined") ? $(this).data('thumbBackgroundColor') : "";
			if(sBackgroundColor !== "")
			{
				var oThumbs = $(this).find('.thumb');
				oThumbs.css('background-color', sBackgroundColor);
			}
		});
	}
}

function initFeaturedProductsGridSlider()
{
	var oFeaturedProductsGridSliderItems = $('.featuredproductsgridslider .hProductItems');

	if(oFeaturedProductsGridSliderItems.length > 0)
	{
		oFeaturedProductsGridSliderItems.each(function(index)
		{
			var sBackgroundColor = (typeof $(this).data('thumbBackgroundColor') !== "undefined") ? $(this).data('thumbBackgroundColor') : "";
			if(sBackgroundColor !== "")
			{
				var oThumbs = $(this).find('.thumb');
				oThumbs.css('background-color', sBackgroundColor);
			}
		});
	}
}

function initForms()
{
	var oCkEditorForms = $('.block[data-type="html"] .htmlEdit form');
	if(oCkEditorForms.length > 0)
	{
		oCkEditorForms.each(function(index)
		{
			if($(this).attr('action') == "mail")
			{
				$(this).on('submit', function(e)
				{
					e.preventDefault();

					var oForm = $(this);
					var oValueLabels = getSimpleFormValues(oForm);
					var oFormName  = {};
					oFormName.name = "formPropertyName";
					oFormName.value = oForm.prop('name');
					oValueLabels.push(oFormName);

					var oCall = callAjax("submitckeditorform", oValueLabels, "post", "/index.cfm/content/ajax/submitckeditorform");
					oCall.success(function(oData)
					{
						if(oData.errorType == '')
						{
							oForm.hide();
							$( "<p>" + tSubmitCkeditorFormSuccess + "</p>" ).insertAfter(oForm);
						}
						else
						{
							// show error message
							showAlert('error', oData.errorMessage, oData.errorUnhandled);
						}
					});
				});
			}
		});
	}
}

function initFlexSliders()
{
	var oCategoryProductsSliders = $('.categoryproducts .flexslider');
	if(oCategoryProductsSliders.length > 0)
	{
		oCategoryProductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.categoryproducts').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oBuyProductsSliders = $('.buyproducts .flexslider');
	if(oBuyProductsSliders.length > 0)
	{
		oBuyProductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.buyproducts').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oCarouselSliders = $('.carousel .flexslider');
	if(oCarouselSliders.length > 0)
	{
		oCarouselSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.carousel').innerWidth();
			var bShowNextSlide = $(this).hasClass('showNextSlide');
			setSlider($(this), iInnerWidth, bShowNextSlide);
		});
	}

	var oFeaturedproductsSliders = $('.featuredproductsgridslider[data-layout="slider"] .flexslider');
	if(oFeaturedproductsSliders.length > 0)
	{
		oFeaturedproductsSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.featuredproductsgridslider[data-layout="slider"]').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oRelatedSliders = $('.related[data-layout="slider"] .flexslider');
	if(oRelatedSliders.length > 0)
	{
		oRelatedSliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.related[data-layout="slider"]').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}


	var oTitleimageslider = $('.titleimageslider .flexslider');
	if(oTitleimageslider.length > 0)
	{
		oTitleimageslider.each(function(index)
		{
			var iInnerWidth = $(this).parents('.titleimageslider').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	var oProductconfigsliders = $('.productconfigslider .productConfigSliders .flexslider');
	if(oProductconfigsliders.length > 0)
	{
		oProductconfigsliders.each(function(index)
		{
			var iInnerWidth = $(this).parents('.productconfigslider').innerWidth();
			setSlider($(this), iInnerWidth);
		});
	}

	$('.htmlslider .flexslider').each(function(index){
		$(this).flexslider({
			animation: "slide",
			animationLoop: false,
			controlNav: true,
			itemMargin: 20,
			slideshow: false,
			touch: true
		});
	});

	if($(window).width() < 768)
	{
		$('.featuredproducts:not(.categoryproducts) .flexslider').each(function(index){
			$(this).flexslider({
				animation: "slide",
				animationLoop: false,
				controlNav: false,
				itemMargin: 0,
				slideshow: false,
				touch: true
			});
		});
	}
}

function initHotSpotImages()
{
	if(isTouchDevice())
	{
		$('#contentContainer .hotspotCanvas').on({
			touchend: function () {
				$(this).parents(".hotspotCanvas").find(".dot").each(function(i,oEl)
				{
					toggleHotSpot($(oEl),"touchend",false);
				});

				toggleHotSpot($(this),"touchend",true);
			}
		}, ".dot:not('.touchend')");

		$('#contentContainer .hotspotCanvas').on({
			touchend: function () {
				toggleHotSpot($(this),"touchend",false);
			}
		}, ".dot.touchend");


		$('#contentContainer').on({
			touchend: function (e)
			{
				if(!$(e.target).hasClass("dot") && !$(e.target).hasClass("productDetailUrl") && !$(e.target).hasClass("freeTextWrapperUrl"))
				{
					$(this).find(".dot").each(function(i,oEl)
					{
						toggleHotSpot($(oEl),"touchend",false);
					});
				}
			}
		}, ".hotspotCanvas");
	}
	else
	{
		$('#contentContainer .hotspotCanvas').on({
			mouseenter: function (e) {
				toggleHotSpot($(this),"mouseenter",true);
			},
			mouseleave: function (e) {
				if($(e.relatedTarget).hasClass("hotspotCanvas"))
				{
					toggleHotSpot($(this),"mouseleave",false);
				}
			},
			click: function () {
				if(typeof $(this).data("href") !== "undefined" && $(this).data("href") !== "")
 				{
					window.location = $(this).data("href");
				}
			}
		}, ".dot:not('.click')");

		$('#contentContainer .hotspotCanvas').on({
			mouseleave: function (e)
			{
				if($(e.relatedTarget).hasClass("hotspotCanvas") || $(e.relatedTarget).hasClass("hotspotCanvasLink") || $(e.relatedTarget).parents(".hotspotCanvas").length == 0)
				{
					toggleHotSpot($(this).parents(".dotWrapper").find(".dot"),"mouseleave",false);
				}
			}
		}, ".popover");
	}

	$('#contentContainer .hotspotCanvas').each(function(i,oEl)
	{
		if($(oEl).find(".dot").length > 0)
		{
			setInterval(function()
			{
				$(oEl).toggleClass('isAnimating')
			}, $(oEl).find(".dot").length*2000);
		}
	});
}

function buyProductsBlockAddSkus(sSkus)
{
	var sParams = '&skus=' + sSkus;
	var oCall = callAjax("buyproductsblockaddskus", sParams, "post", "/index.cfm/content/ajax/buyproductsblockaddskus");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.ErrorType == '')
		{
			// Add to basket successful
			var oBasketDropdowns = $('header:not(.fixedActive) #basketDropdown:visible, header.fixedActive #basketDropdown:visible');
			oBasketDropdowns.html(oData.html).delay(300).queue(function(next)
			{
				oBasketDropdowns.addClass("open");

				setTimeout(function()
				{
					oBasketDropdowns.removeClass('open');
				}, 3000);

				next();
			});
		}
		else
		{
			// show error message
			showAlert('error', oData.ErrorMessage, oData.Unhandled);
		}
	});
}

function initializeMap()
{
	map = new google.maps.Map(document.getElementById('googleMap'),
		mapOptions);

	var markers = googleMapMarkers();
}

function scrollToAnchor(anchor)
{
    $('html,body').animate({scrollTop: $("#"+anchor).offset().top - 100},300);
}

function objectFitFallback(oElem)
{
	var imgUrl = oElem.find('img').prop('src');

	if(imgUrl)
	{
		oElem.css('backgroundImage', 'url("' + imgUrl + '")').addClass('compat-object-fit');
	}
}

function searchShop(location,latitude,longitude)
{
	$('.searchShop .doSearch i').removeClass('icon-caret-right fa fa-caret-right').addClass('icon-spinner icon-spin');
	var sParams = '&location=' + location + '&latitude=' + latitude + '&longitude=' + longitude;
	var oCall = callAjax("closestshop", sParams, "post", "/index.cfm/shop/ajax/closestshop");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$('.shopData').html(oData.html);
			if(oData.empty)
			{
				var fallbackText = $('.shopData').data('fallback');
				$('.fallbacktext').text(fallbackText);
			}
			if(typeof callbackClosestShop !== 'undefined' && !oData.empty)
			{
				callbackClosestShop(oData.shopId,oData.closestLocation,oData.seoUrl);
			}
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.searchShop .doSearch i').removeClass('icon-spinner icon-spin').addClass('icon-caret-right fa fa-caret-right');
	});
}

function showPosition(position) {
	searchShop('',position.coords.latitude,position.coords.longitude);
}
//Creates base styles
function saveContentInline(button,type)
{
	button.button('loading');

	// current date without characters or spaces
	var date        = new Date();
	var currentDate = date.getFullYear().toString() + (date.getMonth() + 1).toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString();

	// check if we are editing a page
	var nameCurrentPage = 'page_' + type + '_' + currentDate;
	if(button.data('currentpagename') !== '')
	{
		nameCurrentPage = button.data('currentpagename');
	}
	if(button.data('block') !== '')
	{
		currentPage = button.data('block');
	}

	// Create object to post to service
	var oContentPage = {};

	// General data
	oContentPage.idTenant 	= tenantId;
	oContentPage.idShop 	= shopId;
	oContentPage.idChannel 	= channelId;
	oContentPage.name 		= nameCurrentPage;
	oContentPage.content 	= {};

	// Object per language
	var code = sCurrentLanguageCode.toUpperCase();
	oContentPage.content[code] = {};

	// Meta
	oContentPage.content[code].meta             = {};
	oContentPage.content[code].meta.title       = '';
	oContentPage.content[code].meta.description = '';
	oContentPage.content[code].meta.url         = '';

	// Properties
	oContentPage.content[code].properties                   = {};
	oContentPage.content[code].properties.title             = '';
	oContentPage.content[code].properties.subtitle          = '';
	oContentPage.content[code].properties.image             = '';
	oContentPage.content[code].properties.tags              = [];
	oContentPage.content[code].properties.tagsLinked        = [];
	oContentPage.content[code].properties.category          = {};
	oContentPage.content[code].properties.showOnInspiration = false;

	// Parent page
	oContentPage.content[code].properties.parent    = {};
	oContentPage.content[code].properties.parent.id = '';

	// Breadcrumbs
	oContentPage.content[code].properties.breadcrumbs = [];

	// Rows
	oContentPage.content[code].blocks = [];
	oContentPage.content[code].rows   = [];

	// Row 1
	var row              = {};
	row.number           = 1;
	row.background       = '';
	row.backgroundImage  = '';
	row.fullWidth        = false;
	row.fullWidthContent = false;
	row.padding          = 0;
	row.marginTop        = 0;
	row.marginBottom     = 0;
	row.width            = currentWidth;

	oContentPage.content[code].rows.push(row);

	var oBlockData   = {};
	oBlockData.width = 12;
	oBlockData.type  = type;
	oBlockData.row   = 1;

	// Get content based on type
	oBlockData.content = {};
	if(type === 'html')
	{
		oBlockData.content.html    = button.parent().find('.htmlEditContent').html();
		oBlockData.content.bgcolor = '';
		oBlockData.content.padding = '';
		oBlockData.content.paddingTop = '';
		oBlockData.content.paddingBottom = '';
		oBlockData.content.paddingLeft = '';
		oBlockData.content.paddingRight = '';
		oBlockData.content.margin = '';
		oBlockData.content.marginTop = '';
		oBlockData.content.marginBottom = '';
		oBlockData.content.marginLeft = '';
		oBlockData.content.marginRight = '';
	}
	else if(type === 'image')
	{
		oBlockData.content.image      = button.parent().find('.original').attr('src');
		oBlockData.content.url        = button.parent().find('.options .imageUrl').val();
		oBlockData.content.imageAlt   = button.parent().find('.options .imageAlt').val();
		oBlockData.content.imageTitle = button.parent().find('.options .imageTitle').val();
		oBlockData.content.borderRadius = button.parent().find('.options .borderRadius').val();

		oBlockData.height = '';
	}
	oContentPage.content[code].blocks.push(oBlockData);

	// Ajax call to save to DB
	var oCall = $.ajax(
	{
		url: '/index.cfm/content/ajax/save?removeContent=1',
		data: JSON.stringify({"contentPage":oContentPage}),
		dataType: 'json',
		contentType: "application/json; charset=utf-8",
		type: 'POST'
	});

	// process result
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			setLinkedPage(currentPage, oContentPage.name, button);
		}
		else if(oData.errorType == 'loggedout')
		{
			location.reload();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.unhandled);
			button.button('reset');
		}
	});
}

function submitNewsletterBlock(oForm)
{
	clearErrors();
	var bValid = validateForm(oForm);
	if (bValid)
	{
		uAjax = "/index.cfm/customer/ajax/subscribe";

		var sEmail  = oForm.find('.inputEmailSubscribe').val();
		var sParams = '&sEmail=' + sEmail;

		var oCall = callAjax('subscribe', sParams, 'post');
		oCall.success(function(oData)
		{
			var oParent = oForm.parents('.blockWrapper');

			if (oData.errorType != '')
			{
				oParent.find('.newsletterBlockTitleText').text('');
				oParent.find('.newsletterBlockSubText').text(oData.errorMessage);
				oParent.find('.newsletterBlockForm').remove();
			}
			else
			{
				$(document).trigger("subscribe",[sEmail]);

				oParent.find('input[type="text"]').val('');
				oParent.find('.newsletterBlockTitleText').text('');
				oParent.find('.newsletterBlockSubText').text(tNewsletterSubscribed);
				oParent.find('.newsletterBlockForm').remove();
			}
		});
	}
	else
	{
		showAlert('error', tSubscribeInvalidInput, true);
	}
}

function setHotSpotPopoverPos(oHotSpot)
{
	var oHotSpotPopover = oHotSpot.parents(".dotWrapper").find(".popover");
	var cpos = oHotSpot.offset();
	var ppos = oHotSpot.parents(".hotspotCanvas").offset();
	var restop = (cpos.top - ppos.top) - oHotSpotPopover.outerHeight() + 1;
	var resleft = (cpos.left - ppos.left) - (oHotSpotPopover.outerWidth() / 2) + 12;

	oHotSpotPopover.css({"left": resleft+"px", "top": restop+"px"});
}

function toggleHotSpot(oHotSpot, sEventType, bShow)
{
	setHotSpotPopoverPos(oHotSpot);

	var oHotSpotPopover = oHotSpot.parents(".dotWrapper").find(".popover");
	var sType = (typeof sEventType !== "undefined") ? sEventType : "";
	if(sType === "click" && oHotSpot.hasClass("mouseenter")) bShow = true;
	var bToggleIn = (typeof bShow !== "undefined") ? bShow : (!oHotSpotPopover.hasClass("in"));

	if(bToggleIn)
	{
		oHotSpotPopover.show();
		oHotSpotPopover.addClass("in");
		oHotSpot.addClass(sType);
	}
	else
	{
		oHotSpotPopover.hide();
		oHotSpotPopover.removeClass("in");
		oHotSpot.removeClass("click mouseenter mouseleave touchend");
	}
}